export const SHIPMENTS_ANALYTICS_SOURCES = {
  REPORT_SYNC_MODE: "report_sync_generation",
  REPORT_ASYNC_MODE: "report_async_generation",
  SHIPMENT_MAP_VIEW: "shipment_map_view",
  SHIPMENT_TABLE_VIEW: "shipment_table_view",
  EXPORT_FORMAT_EXCEL: "export_format_excel",
  SORT_ASCENDING: "sort_ascending",
  SORT_DESCENDING: "sort_descending",
  REPORT_LIMIT_EXCEEDED: "report_download_limit_exceeded",
  REPORT_DOWNLOAD_ERROR: "report_download_error"
} as const;

export const SHIPMENTS_ANALYTICS_EVENTS = {
  PAGE_VIEWED: "Shipments: Page Viewed",
  TAB_CHANGED: "Shipments: Tab Changed",
  PAGINATION_CHANGED: "Shipments: Pagination Changed",
  SORT_CHANGED: "Shipments: Sort Changed",
  VIEW_MODE_CHANGED: "Shipments: View Mode Changed",
  VESSEL_SELECTED: "Shipments: Vessel Selected",
  PREVIEW_OPENED: "Shipment: Preview Opened",
  PREVIEW_CLOSED: "Shipment: Preview Closed",
  FILTERS_APPLIED: "Shipments: Filters Applied",
  FILTERS_CLEARED: "Shipments: Filters Cleared",
  QUICK_FILTER_TOGGLED: "Shipments: Quick Filter Toggled",
  FILTER_TAG_REMOVED: "Shipments: Filter Tag Removed",
  CONFIGURE_COLUMNS_OPENED: "Shipments: Configure Columns Opened",
  COLUMNS_SAVED: "Shipments: Columns Saved",
  COLUMNS_RESET: "Shipments: Columns Reset",
  SUBSCRIPTION_UPLOAD_OPENED: "Shipments: Subscription Upload Opened",
  SUBSCRIPTION_UPLOAD_SUBMITTED: "Shipments: Subscription Upload Submitted",
  COLUMN_DATA_UPLOAD_OPENED: "Shipments: Column Data Upload Opened",
  COLUMN_DATA_UPLOAD_SUBMITTED: "Shipments: Column Data Upload Submitted",
  EXPORT_INITIATED: "Shipments: Export Initiated",
  REPORT_DOWNLOADED: "Shipments: Report Downloaded",
  REPORT_DOWNLOAD_FAILED: "Shipments: Report Download Failed",
  ARCHIVE_INITIATED: "Shipments: Archive Initiated",
  ARCHIVE_CONFIRMED: "Shipments: Archive Confirmed",
  NO_RESULTS: "Shipments: No Results",
  LOAD_ERROR: "Shipments: Load Error",
  TIME_SPENT: "Shipments: Time Spent"
} as const;
